module.exports = __webpack_public_path__ + "static/media/shopping-cart.3091d9bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopping-cart.svg
// module id = 983
// module chunks = 7